import React from 'react'
import './index.less'
import cdn from 'src/helper/cdn'

import lang from '../lang'

export default class extends React.Component {
  state = {
  }

  constructor(props) {
    super(props)
  }

  componentDidMount() {
  }

  componentWillReceiveProps(e) {
  }

  render() {
    let { language, lang, owner } = this.props
    return (
      <div className="owner">
        <div className="title">
          {lang.owner}
        </div>
        <div className="content">
          <img src={owner && owner.avatarurl || ""} className="logo" title={owner && owner.uid || 0} />
          <div className={`item ${language == 'ar' && 'arlang'}`}>
            <div className="name">
              {owner && owner.nickname}
            </div>
            <div className="id">
              ID:{owner && owner.duid}
            </div>
          </div>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// src/pages/app/roomsupport-op/Owner/index.js